// conversationAdapter/text — a message's reader-visible text.

export { textOf };

import { fields, list, str } from "../wireShape.js";

// === Content extraction =======================================================
// MessageContent is an ordered block array; only `content_text` blocks carry
// reader-visible prose. Join them; ignore tool-use / tool-result / image
// blocks (they aren't part of the message the reader sees).

const textOf = (content: unknown): string =>
    list(content)
        .map((raw) => {
            const block = fields(raw);
            return str(block?.get("type")) === "content_text"
                ? (str(block?.get("text")) ?? "")
                : "";
        })
        .join("");
